import { render, staticRenderFns } from "./SmsSameConfig.vue?vue&type=template&id=919f935c&scoped=true&"
import script from "./SmsSameConfig.vue?vue&type=script&lang=js&"
export * from "./SmsSameConfig.vue?vue&type=script&lang=js&"
import style0 from "./SmsSameConfig.vue?vue&type=style&index=0&id=919f935c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919f935c",
  null
  
)

export default component.exports